/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useTheme } from '@/providers/theme';
import {
  useSMSignInUser,
  useSMGetSignInType,
  useSMSendOTP,
  useSMSignInPageGetContent,
} from '@pages/SignInPage/machines';

import toast from 'react-hot-toast';
import { vappContainer } from '@/application';
import { SignInPageService } from '@pages/SignInPage/services';
import {
  PageContainer,
  GoBackLink,
  Heading,
  Logo,
  FormComp,
  SubmitButton,
  OTPComp,
  SubHeading,
  ImageIcon,
} from '../components';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';

export const fillTemplate = (templateString, templateVariables) => {
  return templateString.replace(/\${(.*?)}/g, (_, g) => templateVariables[g]);
};

const MODULE_NAME = 'signInPage';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [email, setEmail] = useState();
  const { signInUserMachine, signInUserSend, signInUserState } =
    useSMSignInUser({});
  const { getSignInTypeState, getSignInTypeSend } = useSMGetSignInType({});
  const { sendOTPState, sendOTPSend } = useSMSendOTP({});
  const { signInPageGetContentState } = useSMSignInPageGetContent({});
  const srv = getSrv();

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  const onIdentifierSubmit = (data: any) => {
    setEmail(data?.email);
    signInUserSend('START', {
      payload: {
        email: data?.email,
      },
    });
  };

  const onLoginSubmit = (email: string, data: any) => {
    signInUserSend('START', {
      payload: {
        email: data.email,
        password: data.password,
      },
    });
  };

  const onOTPSubmit = (data: any) => {
    signInUserSend('VERIFY_OTP', {
      payload: {
        email: email,
        otp: data.otp,
      },
    });
  };

  const _handleResendClick = () => {
    sendOTPSend('START', {
      payload: {
        email: email,
      },
    });
  };

  const _onSignIn = (email: string, password: string, rememberMe: boolean) => {
    signInUserSend('START', {
      payload: {
        email: email,
        password: password,
        rememberMe: rememberMe,
      },
    });
  };

  const onRoleSelect = (token: string, role: any) => {
    signInUserSend('GET_ACCESS_TOKEN', {
      payload: {
        jwtToken: token,
        role: role?.uuid,
      },
    });
  };

  const _getSuccessNotification = () => {
    return null;
  };
  const _getErrorNotification = () => {
    return null;
  };

  const _getPageContent = () => {
    if (signInUserState?.matches('SIGN_IN_USER_SUCCESS')) {
      window.open(`/product/bharat-life-saral-jeevan-bima`, '_self');
    }
    if (
      signInPageGetContentState?.matches('GET_PAGE_CONTENT') ||
      signInUserState?.matches('VERIFY_OTP') ||
      signInUserState?.matches('SIGN_IN_USER') ||
      signInUserState?.matches('SIGN_IN_TOKEN') ||
      signInUserState?.matches('ACCESS_TOKEN')
    ) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingContentSync()?.loading?.GetPageLoading ||
            {})}
        />
      );
    }
    if (
      signInUserState?.matches('SUBMIT_OTP') ||
      signInUserState?.matches('SUBMIT_OTP_FAILED')
    ) {
      let phoneNumber = signInUserState?.event?.data?.value?.smsSent
        ? signInUserState?.event?.data?.value?.primaryContactNo
        : '';
      return (
        <Col md={4} xs={11}>
          <Logo
            logoURL={srv?.agent?.getStaticPageContentSync()?.header?.otp?.logo}
          />
          <GoBackLink />
          <Heading
            title={srv?.agent?.getStaticPageContentSync()?.header?.otp?.title}
          />
          <ImageIcon
            imageIconURL={
              srv?.agent?.getStaticPageContentSync()?.header?.otp?.iconURL
            }
            height={100}
          />
          <SubHeading
            subHeadingText={fillTemplate(
              srv?.agent?.getStaticPageContentSync()?.header?.otp
                ?.subHeadingText,
              { email: email, phoneNumber: phoneNumber }
            )}
          />
          <OTPComp
            renderSubmitButton={renderSubmitButton}
            onFormSubmit={onOTPSubmit}
            onResendClick={_handleResendClick}
          />
        </Col>
      );
    }

    if (signInPageGetContentState?.matches('RENDER_PAGE')) {
      return (
        <Col xs={12} md={12}>
          <Logo
            logoURL={
              srv?.agent?.getStaticPageContentSync()?.header?.identifier?.logo
            }
          />
          <GoBackLink />
          <Heading
            title={
              srv?.agent?.getStaticPageContentSync()?.header?.identifier?.title
            }
          />
          <FormComp
            renderSubmitButton={renderSubmitButton}
            authType={'IDENTIFIER'}
            onFormSubmit={onIdentifierSubmit}
          />
        </Col>
      );
    }

    if (getSignInTypeState?.matches('GET_SIGN_IN_TYPE_FAILURE')) {
      toast.error(getSignInTypeState?.event?.data?.value);
    }
  };
  return (
    <PageContainer>
      {/* {_getSuccessNotification()} */}
      {/* {_getErrorNotification()} */}
      {_getPageContent()}
    </PageContainer>
  );
};
